import { Locale, setDefaultOptions } from "date-fns";
import { ar, de, el, enUS, es, fr, he, it, pt, tr } from "date-fns/locale";
import i18n from "i18next";
import Backend from "i18next-xhr-backend";
import moment from "moment-timezone";
import "moment/locale/ar";
import "moment/locale/de";
import "moment/locale/el";
import "moment/locale/es";
import "moment/locale/fr";
import "moment/locale/he";
import "moment/locale/it";
import "moment/locale/pt";
import "moment/locale/tr";
import { initReactI18next } from "react-i18next";
import { syncDocumentLanguage } from "shared-utils/src/locale";

const locales = ["de", "en", "es", "fr", "it", "el", "he", "tr", "pt", "ar"];
const hostname = window.location.hostname.toLowerCase();
const prefix = hostname.substring(0, 2);

if (
  import.meta.env.VITE_SENTRY_ENVIRONMENT &&
  import.meta.env.VITE_SENTRY_ENVIRONMENT === "production"
) {
  if (window.location.hostname.substring(0, 2) === "he") {
    window.location.assign("https://nbafantasy.sport5.co.il");
  }

  if (window.location.hostname === "nbafantasy.sky.it") {
    window.location.assign("https://it.nbafantasy.nba.com");
  }
}

if (prefix === "gr") {
  const redirectUrl =
    import.meta.env.VITE_SENTRY_ENVIRONMENT === "production"
      ? "https://nbafantasy.nba.com"
      : import.meta.env.VITE_SENTRY_ENVIRONMENT === "staging"
        ? "https://nba.staging.ismgames.com"
        : "https://nba.app";

  window.location.assign(redirectUrl);
}

const hostnameLocale =
  prefix === "gr"
    ? "el"
    : hostname.includes("sport5")
      ? "he"
      : hostname.includes("lequipe")
        ? "fr"
        : prefix === "br"
          ? "pt"
          : prefix;
// hack for the GR vs EL greek domain/locale,
// sport5 affiliate in HE, and lequipe affiliate in FR

const lng = locales.indexOf(hostnameLocale) >= 0 ? hostnameLocale : "en";
syncDocumentLanguage(lng);
export const dateLocales: Record<string, Locale> = {
  de,
  en: enUS,
  es,
  fr,
  it,
  el,
  he,
  tr,
  pt,
  ar,
};
// Update moment, date-fns, and document language
i18n.on("languageChanged", function (lng) {
  moment.locale(lng);
  setDefaultOptions({ locale: dateLocales[lng] });
  syncDocumentLanguage(lng);
});

i18n
  .use(Backend)
  .use(initReactI18next)

  .init({
    ns: ["common"],
    defaultNS: "common",
    lng,
    fallbackLng: "en", // to stop trying to fetch dev transations
    debug: false,
    interpolation: {
      escapeValue: false, // react already safe from xss as escaped by default
    },
    initImmediate: false, // makes the language code accessible in src/theme.ts (PR #4035),
  });

export default i18n;
